import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { Box, Stack } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import {
  crossIcon,
  crossIconDiv,
  fontSizeSchemes,
} from "../../../../assets/commonFunction";
import { handleGetTaskReopenedHistory } from "../../../../appStore/actions/ArkchatGroup/action";
import {
  getTaskStatusLabels,
  MessageType,
  priorityValueColor,
  priorityValueLable,
} from "../../../../utils/constant";
import moment from "moment";
import useAppSelectors from "../../../../customHooks/useAppSelectors";
import TaskStatusButton from "../../../../components/TaskStatusButton/TaskStatusButton";
import { getOrdinal } from "../../../../utils/helper";

const classes = {
  drawerBody: {
    minWidth: "25.25rem",
    maxWidth: "25.25rem",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
  chatpri: {
    borderRadius: "3px",
    lineHeight: "14px",
    fontSize: fontSizeSchemes.font14,
    fontWeight: 400,
    whiteSpace: "nowrap",
  },
};

const ReopenedHistory = ({ taskItem, setReopenedHostoryDrawer }) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const appConstant = t("AppConstant", { returnObjects: true });

  const [historyData, setHistoryData] = useState([]);
  const { currentUserData } = useAppSelectors();
  const dispatch = useDispatch();
  const taskStatusLabels = getTaskStatusLabels(appConstant);

  useEffect(() => {
    dispatch(handleGetTaskReopenedHistory(taskItem?.id)).then((res) => {
      setHistoryData(res);
    });
  }, []);

  return (
    <Box sx={classes?.drawerBody}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={classes.header}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography sx={classes.iconDiv}>
            <CloseIcon
              sx={classes.iconn}
              onClick={() => setReopenedHostoryDrawer(false)}
            />
          </Typography>
          <Typography color={"black"}>{appContent?.KEY358}</Typography>
        </Stack>
      </Stack>

      <Box>
        <Box padding="8px 19px">
          <Typography
            sx={{ mb: "0.8rem", fontWeight: "600", fontSize: "14px" }}
          >
            {appContent?.KEY363} : {historyData?.[0]?.data?.from?.name}
          </Typography>
          <Typography
            sx={{ mb: "0.8rem", fontWeight: "600", fontSize: "14px" }}
          >
            {appContent?.KEY364} : {historyData?.[0]?.data?.assignee?.name}
          </Typography>
          {historyData?.map((item, index) => (
            <Box mb={"0.8rem"}>
              <Typography
                sx={{ mb: "0.8rem", fontWeight: "600", fontSize: "14px" }}
              >
                {getOrdinal(index + 1)} {appContent?.KEY362}
              </Typography>
              <Box sx={{ mb: "0.8rem" }}>
                <Typography
                  sx={classes.chatpri}
                  border={"1px solid transparent"}
                >
                  {appContent?.KEY190} :
                  <span
                    style={{
                      display: "inline-block",
                      width: "13px",
                      height: "13px",
                      verticalAlign: "middle",
                      margin: "-1px 5px 0px 5px",
                      backgroundColor: priorityValueColor[item?.data?.priority],
                    }}
                  ></span>
                  {priorityValueLable[item?.data?.priority]}
                </Typography>
              </Box>

              <Box sx={{ mb: "0.8rem" }}>
                <Typography
                  sx={classes.chatpri}
                  border={"1px solid transparent"}
                >
                  {" "}
                  {appContent?.KEY359} :{" "}
                  {moment(item?.data?.due_date).format(
                    currentUserData?.userDateFormat
                  )}
                </Typography>
              </Box>

              <Box sx={{ mb: "0.8rem" }}>
                <Typography
                  sx={classes.chatpri}
                  border={"1px solid transparent"}
                >
                  {item?.data?.type === MessageType?.Approval
                    ? appContent?.KEY343
                    : appContent?.KEY342}{" "}
                  :{" "}
                  {moment(Math.floor(item?.data?.timetoken / 10000)).format(
                    currentUserData?.userDateFormat
                  )}
                </Typography>
              </Box>

              <Box sx={{ mb: "0.8rem" }}>
                <Typography
                  sx={classes.chatpri}
                  border={"1px solid transparent"}
                >
                  {appContent?.KEY360} :{" "}
                  {moment
                    .unix(item?.data?.start_time)
                    .format(currentUserData?.userDateFormat)}
                </Typography>
              </Box>

              <Box sx={{ mb: "0.8rem" }}>
                <Typography
                  sx={classes.chatpri}
                  border={"1px solid transparent"}
                >
                  {appContent?.KEY353} : {item?.data?.estimated_time?.timeValue}{" "}
                  {item?.data?.estimated_time?.timeType}
                </Typography>
              </Box>

              <Box sx={{ mb: "0.8rem" }}>
                <Typography
                  sx={classes.chatpri}
                  border={"1px solid transparent"}
                >
                  {appContent?.KEY324} :{" "}
                  {moment
                    .unix(item?.data?.end_time)
                    .format(currentUserData?.userDateFormat)}
                </Typography>
              </Box>

              <Box sx={{ mb: "0.8rem" }}>
                <Typography
                  sx={classes.chatpri}
                  border={"1px solid transparent"}
                >
                  {appContent?.KEY361} : {item?.data?.actual_time?.timeValue}{" "}
                  {item?.data?.actual_time?.timeType}
                </Typography>
              </Box>

              <Box sx={{ mb: "0.8rem" }}>
                <Typography
                  sx={classes.chatpri}
                  color={
                    item?.data?.actual_time?.timeValue <
                      item?.data?.estimated_time?.timeValue ||
                    Math.abs(item?.data?.diff_time?.timeValue) === 0
                      ? "#007F8F"
                      : "#DB0011"
                  }
                  border={"1px solid transparent"}
                >
                  {Math.abs(item?.data?.diff_time?.timeValue) > 0 ? (
                    <>
                      {Math.abs(item?.data?.diff_time?.timeValue)}{" "}
                      {item?.data?.diff_time?.timeType}{" "}
                      {item?.data?.actual_time?.timeValue <
                      item?.data?.estimated_time?.timeValue
                        ? "Less"
                        : "More"}
                    </>
                  ) : (
                    <>{appContent?.KEY270}</>
                  )}
                </Typography>
              </Box>

              <Box sx={{ mb: "0.8rem" }}>
                <Typography
                  sx={classes.chatpri}
                  border={"1px solid transparent"}
                >
                  {appContent?.KEY347} :{" "}
                  {priorityValueLable[taskItem?.priority]}
                </Typography>
              </Box>

              <Box sx={{ mb: "0.8rem" }}>
                <Typography
                  sx={classes.chatpri}
                  border={"1px solid transparent"}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {appContent?.KEY344} :{" "}
                    <TaskStatusButton
                      item={item?.data}
                      status="task"
                      isCondition={
                        taskStatusLabels[item?.data?.task_status] &&
                        taskStatusLabels[item?.data?.task_status] !== ""
                      }
                      showTextStatus={false}
                    />
                  </span>
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ReopenedHistory;
